import React, { useState } from 'react';

import { H3, H4 } from '../../primitives/appTitle';
import AppSection from '../../primitives/appSection';
import { FrontCommonMessages } from '../../appCommonTranslations';
import { ShText } from '@shoootin/translations';
import CoverVideo from '../../components/coverVideo';
import VideoModal from '../../components/video/videoModal';
import PatternSvg from '../../components/svg/patternSvg';
import SliderOfferWrapper from './sliderOfferWrapper';
import { AppVideo, ProfessionShootingType } from '../../appConstants';
import { MetierPageOffersVideo } from './metierPageOffers';
import { getProfessionMessage } from '../../appMessageDefinitions';

const MetierVideoSection = ({
  profession,
  video,
  offers,
}: {
  profession: ProfessionShootingType;
  video: AppVideo;
  offers?: MetierPageOffersVideo;
}) => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <AppSection className="metier-section video right">
      <div className="metier-content">
        <div className="metier-text">
          <H3>
            <ShText message={FrontCommonMessages.professionVideoSectionTitle} />
          </H3>
          <p>
            <ShText
              message={getProfessionMessage(profession, 'videoDescription')}
            />
          </p>
          {/*<AppLink>*/}
          {/*<AppText message={FrontCommonMessages.seeGallery} />*/}
          {/*</AppLink>*/}
        </div>

        <div className="metier-gallery">
          {/*<div className="metier-gallery-video">*/}
          {/*<div className="metier-video__cover">*/}
          <>
            <CoverVideo
              path={video.videoImg}
              onClick={() => setShowVideo(true)}
            />
            {showVideo && (
              <VideoModal
                videoId={showVideo ? video.videoUrl : undefined}
                onClose={() => setShowVideo(false)}
              />
            )}
          </>
          {/*</div>*/}
          {/*</div>*/}
        </div>

        {/*<div className="metier-gallery">*/}
        {/*<SliderWrapper*/}
        {/*slides={values.video.gallery}*/}
        {/*renderSlide={slide => <GallerySlide slide={slide} />}*/}
        {/*className="gallery-slider"*/}
        {/*showNav*/}
        {/*showPagination*/}
        {/*/>*/}
        {/*<span className="metier-pattern" data-parallax="0.1">*/}
        {/*<PatternSvg />*/}
        {/*</span>*/}
        {/*</div>*/}
      </div>
      {offers && (
        <>
          <div className="metier-slider">
            <H4>
              <ShText
                message={getProfessionMessage(profession, 'videoOffers')}
              />
              <span className="metier-pattern" data-parallax="-0.1">
                <PatternSvg />
              </span>
            </H4>
            <SliderOfferWrapper
              offers={offers.videoOffers}
              currency={offers.currency}
              shootingType={profession}
            />
          </div>

          {/*<div className="metier-options">
            <H4>Options supplémentaires</H4>

            <Options options={{} as any} />
            </div>*/}
        </>
      )}
    </AppSection>
  );
};

export default MetierVideoSection;
